module.exports = __webpack_public_path__ + "static/media/marker-full.e2aa0e73.svg";